import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ClockCircleOutlined, UserOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { BeeyLocale } from 'libs/locales/locale';
import LocaleTag from '../../../LocaleTag';
import styles from './style.module.less';
import ChangeList from '../ChangeList';
const getLocales = (changes) => {
    const locales = (changes !== null && changes !== void 0 ? changes : [])
        .map(({ path }) => (path.startsWith('Localizations.') ? path.split('.')[1] : undefined))
        .filter((l) => l !== undefined);
    return locales.filter((l, i) => locales.indexOf(l) === i);
};
const VersionItem = ({ entry, isSelected, onSelect }) => {
    const locales = getLocales(entry.changes);
    const timestamp = dayjs(entry.timestamp).format('DD.MM.YY HH:mm');
    const { changes, author } = entry;
    return (_jsxs("div", { className: `${styles.versionRow} ${isSelected === true ? styles.versionRowSelected : ''}`, role: "button", tabIndex: 0, onClick: onSelect, onKeyDown: (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                onSelect();
            }
        }, children: [_jsxs("div", { className: styles.itemHeader, children: [_jsxs("div", { className: styles.itemOperation, children: [_jsxs("div", { className: styles.timestamp, children: [_jsx(ClockCircleOutlined, {}), ' ', timestamp] }), _jsxs("div", { className: styles.author, children: [_jsx(UserOutlined, {}), ' ', author] })] }), locales.map((locale) => (_jsx(LocaleTag, { locale: BeeyLocale.fromCode(locale) }, locale)))] }), _jsx(ChangeList, { changes: changes })] }));
};
export default VersionItem;
